import { render, staticRenderFns } from "./subscription-terms.vue?vue&type=template&id=da44df0c&scoped=true"
import script from "./subscription-terms.vue?vue&type=script&lang=js"
export * from "./subscription-terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da44df0c",
  null
  
)

export default component.exports